import Pagination from './Pagination';
import Input from './Input';
import Select from './Select';
import Button from './Button';
import Tab from './Tab';
import Card from './Card';
// import PhoneInput from "./PhoneInput";
// import VerificationInput from "./VerificationInput";
import TextArea from './TextArea';
import File from './File';
import Modal from './Modal';
import { Switch } from "@heroui/switch";
import { Spinner } from "@heroui/spinner";
import DropdownButton from './DropdownButton';

export const NextUI = {
  Pagination,
  Input,
  Select,
  Button,
  Tab,
  // PhoneInput,
  // VerificationInput,
  TextArea,
  Card,
  File,
  Modal,
  Switch,
  Spinner,
  DropdownButton,
};
